<script>
  import { navigate } from "svelte-navigator";
  import { gridTypes } from "../scripts/render";

  const gridClasses = ["matrix", "half-x", "half-y"];
  let currentGrid;

</script>

<main>
  <h4>Select a grid</h4>
  <section>
    {#each gridTypes as grid, index}
      <div
        type={gridClasses[index]}
        class:active={currentGrid == index}
        on:click={() => (currentGrid = index)}
      >
        {#each grid as row}
          {#each row as col}
            <div />
          {/each}
        {/each}
      </div>
    {/each}
  </section>

  <ion-button
    color="dark"
    disabled={currentGrid == undefined}
    on:click={() => navigate("/time/" + currentGrid)}
  >
    Next <ion-icon name="arrow-forward-outline" />
  </ion-button>
</main>

<style>
  main {
    padding: 5px;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
  }

  main h4::before {
    content: "1/2";
    letter-spacing: 1px;
    background: var(--ion-color-light-tint);
    color: var(--ion-color-step-850);
    display: inline-block;
    width: 30px;
    height: 30px;
    font-size: 12px;
    vertical-align: middle;
    text-align: center;
    line-height: 30px;
    border-radius: 50%;
    margin-right: 15px;
  }

  main button ion-icon {
    vertical-align: middle;
    font-size: 20px;
  }

  main section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  main section > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1px;
    aspect-ratio: 1;
    opacity: calc(var(--grid-opacity) * 3);
    --background: var(--ion-color-step-200);
  }

  main section > div.active {
    --background: var(--ion-color-success);
    opacity: 1;
  }

  main section > div[type="half-x"] {
    grid-template-columns: 1fr 1fr;
  }

  main section > div[type="half-y"] {
    grid-template-columns: 1fr;
  }

  main section > div > div {
    background-color: var(--ion-color-step-650);
    border-radius: 4px;
  }
  main section > div.active {
    --ion-color-step-650: var(--ion-color-success);
  }

  ion-button {
    margin-top: 20vh;
    align-self: center;
  }

</style>
